import { get } from 'lodash';
import { makeApiCall } from '../../../../redux/actions/common/common-action';
import { API_URL } from '../../../../utils/config';
import { IPanValidateProp } from '../../utils/interface';
import { PAN_VERIFICATION_SCREEN } from '../../utils/constants';

export const panNumberVerification = async (
  values: { panCardNumber: string; panName: string },
  dispatch: (data: any) => void,
  props: IPanValidateProp
): Promise<any> => {
  const { storeIsPanVerified, activateLoader, isPanVerified } = props;
  const error = {
    panCardNumber: undefined
  };
  const panCardNumber = values?.panCardNumber;
  if (isPanVerified) return;
  activateLoader();
  if (panCardNumber.length === 10) {
    try {
      const data = {
        panNumber: panCardNumber,
        panName: values?.panName
      };
      const response = await makeApiCall({
        method: 'post',
        url: `${API_URL}/niumForex/pan-card/validate`,
        withCredentials: true,
        data
      });
      if (!response?.data?.success) {
        error.panCardNumber = response?.data?.message;
      }
    } catch (er) {
      //@ts-ignore
      error.panCardNumber = get(
        er,
        'response.data.data.message',
        PAN_VERIFICATION_SCREEN.defaultErrorMsg
      );
    }
  }
  if (error.panCardNumber) {
    throw error;
  } else {
    dispatch(storeIsPanVerified(true));
  }
};

export const panLenValidator = (value: string): string | undefined => {
  return value.length === 10 ? undefined : PAN_VERIFICATION_SCREEN.lengthError;
};

export const panNameVerification = async (
  values: { panName: string },
  props: any
): Promise<any> => {
  const error = {
    panName: undefined
  };
  const { storeIsPanNameVerified, activateLoader } = props;
  const panName = values?.panName;
  if (panName) {
    activateLoader();
    try {
      const params = { name: panName };
      const response = await makeApiCall({
        method: 'get',
        url: `${API_URL}/niumForex/pan-card/validate-pan-name`,
        withCredentials: true,
        params
      });
      if (!response?.data?.success) {
        error.panName = response?.data?.message;
      } else {
        storeIsPanNameVerified(true);
      }
    } catch (er) {
      storeIsPanNameVerified(false);
      error.panName = get(
        er,
        'response.data.data.message',
        PAN_VERIFICATION_SCREEN.defaultErrorMsg
      );
    }
  }
  if (error.panName) {
    throw error;
  }
};

export const validateStartsWithTwoUppercase = (value: string) => {
  const prefix = value.slice(0, 2);
  if (!/^[A-Z]{2}$/.test(prefix)) {
    return 'The first 2 characters must be uppercase letters.';
  }
  return undefined;
};
